/*
  The byte order for values in Modbus data frames is most 
  significant byte of a multi-byte value is sent before the others.
  Endianess: Big-endian
*/

import {crc16modbus} 		from "crc";
import Serial				from "serial";


/* exceptions */
const ILLEGAL_FUNCTION = 1;
const ILLEGAL_DATA_ADDRESS = 2;
const ILLEGAL_DATA_VALUE = 3;
const SLAVE_DEVICE_FAILURE = 4;
const ACKNOWLEDGE = 5;
const SLAVE_DEVICE_BUSY = 6;
const NEGATIVE_ACKNOWLEDGE = 7;
const MEMORY_PARITY_ERROR = 8;

/* functions codes */
const READ_COIL_STATUS = 1;
const READ_INPUT_STATUS = 2;
const READ_HOLDING_REGISTERS = 3;
const PRESET_MULTIPLE_REGISTERS = 16;
const READ_INPUT_REGISTER = 4;
const FORCE_SINGLE_COIL = 5;
const PRESET_SINGLE_REGISTER = 6;
const READ_EXCEPTION_STATUS = 7;

/* offsets */
const OFFSET_DEVICE_ADDRESS = 0;
const OFFSET_FUNCTION_CODE = 1;
const OFFSET_DATA_BYTES = 2;
const OFFSET_LENGTH = 4;
const OFFSET_CRC = 6;

//const OFFSET_DEVICE_ADDRESS = 0;
//const OFFSET_FUNCTION_CODE = 1;
const OFFSET_STARTING_ADDRESS = 2;
const OFFSET_NUMBER_OF_REGISTERS = 4;
const OFFSET_BYTE_COUNT = 6;
const OFFSET_DATA = 7;

/*
  http://www.modbus.org/docs/Modbus_over_serial_line_V1.pdf :
  Intervals of up to one second may elapse between characters within the message. Unless the user has configured a longer timeout,
  an interval greater than 1 second means an error has occurred. Some Wide-Area-Network application may require a timeout in the 4
  to 5 second range. 
*/

const TIMEOUT = 2000;


class Modbus {
  constructor(bus) {
    this.__bus = bus;
    /*
        Modbus RTU use 11-bit char, regardless using parity or not. The formula should be : 11 * 1000000 / ( baud_rate ) for one char time, 
        this applies for baud rate <= 19200 bps. For baud rate > 19200 bps, fixed time is used, which are 1750 micro seconds for 3.5 char time, 
        and 750 micro seconds for 1.5 char time    
    */
    if (this.__bus instanceof Serial) {
      if (this.__bus.cfgetospeed()<=19200)
        this.IFDELAY = Math.ceil((11 * 1000  / ( this.__bus.cfgetospeed())) * 3.5);
      else
        this.IFDELAY = Math.ceil(1.75);
    }
  }
  open(path, config) {
    return( new Promise(function(resolve, reject) {
      this.__bus = new Serial();

      this.__bus.onerror = function(event) {
        reject(event.message);
      }.bind(this);

      this.__bus.onsuccess = function(event) {
        this.__bus.onsuccess = function(event) {
          /* set inter-frame delay */
          if (this.__bus.cfgetospeed()<=19200)
            this.IFDELAY = Math.ceil((11 * 1000  / ( this.__bus.cfgetospeed())) * 3.5);
          else
            this.IFDELAY = Math.ceil(1.75);
          resolve(true);
        }.bind(this);
        this.__bus.flush();
      }.bind(this);

      this.__bus.open(path, config);

    }.bind(this)) );
  }
  close() {
    return( new Promise(function(resolve, reject) {
      this.__bus.onerror = function(event) {
        reject(event.message);
      }.bind(this);
      this.__bus.onsuccess = function(event) {
        resolve(true);
      }.bind(this);
      this.__bus.close();
    }.bind(this)) );
  }  
  readCoilStatus() {
  }
  readInputStatus() {
  }
  /* length: read number of registers, 1 register = 1 word = 2 bytes */
  readHoldingRegisters(address, dataAddress, length) {
    //console.log(`readHoldingRegister(${address}, ${dataAddress}, ${length})`);
    var promise = new Promise(function(resolve, reject) {
      setTimeout(function() {
        this.__bus.onerror = function() {
          reject( new Error("IO Error") );
        };
        var uint8Array = new Uint8Array(8);
        var dataView = new DataView(uint8Array.buffer);

        dataView.setUint8(OFFSET_DEVICE_ADDRESS, address);
        dataView.setUint8(OFFSET_FUNCTION_CODE, READ_HOLDING_REGISTERS);
        dataView.setUint16(OFFSET_DATA_BYTES, dataAddress);
        dataView.setUint16(OFFSET_LENGTH, length);
        dataView.setUint16(OFFSET_CRC, crc16modbus(uint8Array.slice(0, OFFSET_CRC).buffer), true);

        /*slave address: 1byte, function code: 1byte, length byte: 1byte, data, crc: 2byte */
        var result = new Uint8Array(1+1+1+length*2+2);
        var received = 0;	    

        this.__bus.onmessage = function(event) {
          var uint8Array = new Uint8Array(event.data);
          //console.log("rx: "+ uint8Array);
          result.set(uint8Array, received);
          received += uint8Array.length;	      

          /* here we have enough bytes to check the response code */
          if (received>=3) {          
            var dataView = new DataView(result.buffer);
            var device_address = dataView.getUint8(0);
            var function_code = dataView.getUint8(1);
            if (function_code != READ_HOLDING_REGISTERS) {
              var exception_code = dataView.getUint8(2);
              reject( new Error(exception_code) );
            }          
          }

          if (received>=result.length) {	    
            //console.log("done: "+ result);
            result = result.slice(3, -2);

            /* 
		  http://www.modbus.org/docs/Modbus_Application_Protocol_V1_1b.pdf :
		  The register data in the response message are packed as two bytes per register, with the
		  binary contents right justified within each byte. For each register, the first byte contains the
		  high order bits and the second contains the low order bits. 
		*/

            /* TODO: this is a bug, do not swap bytes*/
            for (var i=0, holder; i<result.length; i+=2) {
              holder = result[i];
              result[i] = result[i+1];
              result[i+1] = holder;
            }          

            resolve(result.buffer);
          }
        }
        //console.log("tx:"+uint8Array);
        this.__bus.onsuccess = function(){}
        this.__bus.send(uint8Array);
        //console.log(uint8Array);
        //this.__bus.flush();
        /* inter frame delay */  
      }.bind(this), this.IFDELAY);
    }.bind(this));


    var timeout = new Promise(function(resolve, reject) {
      setTimeout(function() {
        reject("timeout");
      }, TIMEOUT);
    });

    return Promise.race([promise, timeout]);
  }
  presetMultipleRegisters(address, dataAddress, data) {
    var promise = new Promise(function(resolve, reject) {
      setTimeout(function() {
        /*
	    REQUEST
	    Slave Address 11
	    Function 10
	    Starting Address Hi 00
	    Starting Address Lo 01
	    No. of Registers Hi 00
	    No. of Registers Lo 02
        data
	    Error Check (LRC or CRC) ––
	  */

        //var uint8Array = new Uint8Array(7+2+data.length*2);
        var uint8Array = new Uint8Array(7+2+data.byteLength);
        var dataView = new DataView(uint8Array.buffer);
        dataView.setUint8(OFFSET_DEVICE_ADDRESS, address);
        dataView.setUint8(OFFSET_FUNCTION_CODE, PRESET_MULTIPLE_REGISTERS);
        dataView.setUint16(OFFSET_STARTING_ADDRESS, dataAddress);
        //dataView.setUint16(OFFSET_NUMBER_OF_REGISTERS, data.length);
        dataView.setUint16(OFFSET_NUMBER_OF_REGISTERS, Math.trunc(data.byteLength/2));
        //dataView.setUint8(OFFSET_BYTE_COUNT, data.length*2);
        dataView.setUint8(OFFSET_BYTE_COUNT, data.byteLength);
        //uint8Array.set(values, OFFSET_DATA);

        uint8Array.set( new Uint8Array(data), OFFSET_DATA);
        /*
      for (var i = 0; i < data.length; i++) {
        dataView.setUint16(OFFSET_DATA + 2 * i, data[i]);
      }
*/      

        //for (var i = 0; i < data.byteLength; i++) {
        //  dataView.setUint8(OFFSET_DATA + i, data[i]);
        //}
        //dataView.setUint16(OFFSET_DATA+data.length*2, crc16modbus(uint8Array.slice(0, -2).buffer), true);
        dataView.setUint16(OFFSET_DATA+data.byteLength, crc16modbus(uint8Array.slice(0, -2).buffer), true);

        var result = new Uint8Array(8);
        var received = 0;

        this.__bus.onmessage = function(event) {
          /* 
          Response
          Function code 1 Byte 0x10
          Starting Address 2 Bytes 0x0000 to 0xFFFF
          Quantity of Registers 2 Bytes 1 to 123 (0x7B)

          Error
          Error code 1 Byte 0x90
          Exception code 1 Byte 01 or 02 or 03 or 04 
        */

          var uint8Array = new Uint8Array(event.data);
          //console.log("rx: "+uint8Array);
          var dataView = new DataView(uint8Array.buffer);
          var device_address = dataView.getUint8(0);
          var function_code = dataView.getUint8(1);
          if (function_code != PRESET_MULTIPLE_REGISTERS) {
            var exception_code = dataView.getUint8(2);
            reject( new Error(exception_code) );
          } else {
            //var starting_address = dataView.getUint16(2);
            //var number_of_registers = dataView.getUint16(4);
            resolve();
          }
        };
        //console.log("tx: " + uint8Array);
        this.__bus.send(uint8Array);
        /* inter-frame delay */
      }.bind(this), this.IFDELAY);
    }.bind(this));

    var timeout = new Promise(function(resolve, reject) {
      setTimeout(function() {
        reject("timeout");
      }, TIMEOUT);
    });

    return Promise.race([promise, timeout]);    
  }
  readInputRegisters() {
  }
  forceSingleCoil() {
  }
  presetSingleRegister() {
  }
  readExceptionStatus() {
  }
}

export default Modbus;